import { render, staticRenderFns } from "./UsersFilters.vue?vue&type=template&id=660428d5&"
import script from "./UsersFilters.vue?vue&type=script&lang=js&"
export * from "./UsersFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports